export const LIVE_RECOVERY_KEY = "dotnetbot.visitor-live";
export const LIVE_BROWSER_KEY = "dotnetbot.visitor-browser";
const TAB_KEY = "dotnetbot.visitor-tab";
type Store = Pick<Storage, "getItem" | "setItem" | "removeItem">;
export function tokenIdentity(token: string | null): string {
  if (!token) return "guest";
  try {
    const p = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return JSON.stringify([p.sub ?? p["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
      p.org ?? p.organizationId, p.sst]);
  } catch { return token; } // Detection only; server /auth/me authenticates.
}
export type RecoveryScope = { apiKey: string; actor: string; browser: string; tab: string };
export type LiveRecovery = {
  scope: RecoveryScope;
  retryScope: string;
  requestKey: string;
  request: Record<string, unknown>;
  sessionId?: string;
  visitorToken?: string;
};
export function recoveryScope(apiKey: string, actor: string, local: Store, session: Store): RecoveryScope {
  let browser = local.getItem(LIVE_BROWSER_KEY);
  if (!browser) local.setItem(LIVE_BROWSER_KEY, browser = crypto.randomUUID());
  let tab = session.getItem(TAB_KEY);
  if (!tab) session.setItem(TAB_KEY, tab = crypto.randomUUID());
  return { apiKey, actor, browser, tab };
}
export function sameRecoveryScope(a: RecoveryScope, b: RecoveryScope) {
  return a.apiKey === b.apiKey && a.actor === b.actor && a.browser === b.browser && a.tab === b.tab;
}
export function readLiveRecovery(store: Store, scope: RecoveryScope): LiveRecovery | null {
  try {
    const r = JSON.parse(store.getItem(LIVE_RECOVERY_KEY) || "null") as LiveRecovery | null;
    if (!r) return null;
    if (!r.scope || !sameRecoveryScope(r.scope, scope) || !r.retryScope || !r.requestKey ||
        !r.request || r.request.apiKey !== scope.apiKey ||
        (!!r.sessionId !== !!r.visitorToken)) throw new Error("Mismatched recovery");
    return r;
  } catch {
    store.removeItem(LIVE_RECOVERY_KEY);
    return null;
  }
}
export function writeLiveRecovery(store: Store, record: LiveRecovery) {
  store.setItem(LIVE_RECOVERY_KEY, JSON.stringify(record));
}
export type VisitorLiveMessage = {
  id: string; sender: string; content: string; createdAt: string;
  attachmentUrl?: string | null; attachmentName?: string | null; attachmentMime?: string | null;
};
export function restoreLiveMessages(messages: VisitorLiveMessage[]) {
  return messages.map(m => ({
    id: m.id,
    role: (m.sender === "visitor" ? "user" : m.sender === "operator" ? "agent" : "system") as "user" | "agent" | "system",
    content: m.content, timestamp: new Date(m.createdAt),
    attachmentUrl: m.attachmentUrl ?? undefined,
    attachmentName: m.attachmentName ?? undefined,
    attachmentMime: m.attachmentMime ?? undefined,
  }));
}
